export LayoutRoute from './layout';
export LoginRoute from './login';
export SignUpRoute from './signup';
export RecoverRoute from './recover';
export ResetPasswordRoute from './reset-password';



// WEBPACK FOOTER //
// ./src/routes/auth/index.js